var urlServeru = "https://server.recomp.tld/ajax/ajax-produkt.php?idProduktu=";

function pd_sekce_detail($JsonData, $nazev, $obj) {
  var c = false;
  /*
  Lc.f("pd_sekce_detail");
  Lc.log($nazev);
  Lc.log($obj);
  Lc.log("$JsonData", $JsonData);
  */

  var $D = $JsonData.obj;
  var $kod = "";
  if ($obj.onlyPc && $D.MACHINE_TYPE != "pc") {
    return "";
  }

  if ($obj.onlyNtb && $D.MACHINE_TYPE != "ntb") {
    return "";
  }
  var $items = fce.get($obj, "items") || false;
  if (!$items || !Object.keys($items).length) return "";

  for (var $k in $items) {
    var $val = $items[$k];
    var $nazevParametru = $val.param;
    //Lc.log("$nazevParametru", $nazevParametru);

    var $a = $D["DATA_JSON"][$nazevParametru] || "";
    $a = $a.toString();
    if ($a == "none") {
      $a = "";
    }
    if (!$a.length) continue;
    var $tooltip = "";
    if ((c = $val.help)) {
      $tooltip =
        '<strong class="show-tooltip spI" title="" data-original-title="' +
        c +
        '"><em>?</em></strong>';
    }

    var $b = "<h4> " + $k + " " + $tooltip + "</h4>";
    $b += "<strong>" + $a + "</strong>";

    $kod += '<div class="a">' + $b + "</div>";
  } //for

  if (!$kod.length) return "";
  return (
    '<div class="item ' +
    $obj.zkr +
    '"><h3>' +
    $nazev +
    '</h3><div class="s">' +
    $kod +
    "</div></div>"
  );
}

function pd_sekce(data) {
  var $valMenu = window.Parametry["PC_NTB"]["sekce"];
  var $kod = "";
  for (var $k in $valMenu) {
    var $val = $valMenu[$k];
    var $a = pd_sekce_detail(data, $k, $val);
    $kod += $a;
  } //for

  if (!$kod.length) return "";
  return '<div class="sekce"><div class="flx">' + $kod + "</div></div>";
}
function pd_rozhrani_detail($JsonData, $obj) {
  Lc.f("pd_rozhrani_detail");
  Lc.log(" $R", $obj);
  Lc.log(" $data", $JsonData);
  var c, c1;
  var $kod = "";
  var $D = $JsonData.obj;

  var $items = fce.get($obj, "items") || false;
  if (!$items || !Object.keys($items).length) return "";

  for (var $k in $items) {
    Lc.log("fpreach", $k);
    var $val = $items[$k];
    var $nazevParametru = $val.param;
    /*
    Lc.log("arr", $D["DATA_JSON"]["ni_ports"]);
    Lc.log("$nazevParametru", $nazevParametru);
    */

    var b = fce.f_search_in_object(
      $D["DATA_JSON"]["ni_ports"],
      $nazevParametru,
      "Code"
    );

    Lc.h("b", b);
    Lc.log("cesta", Top.shoptetUpload);

    if (!b) continue;
    else if (!b.Value) continue;

    var $tooltip = "";
    if ((c = $val.help)) {
      $tooltip =
        '<strong class="show-tooltip spI" title="" data-original-title="' +
        c +
        '"><em>?</em></strong>';
    }

    var $obr = "";
    if ((c = $val.obr)) {
      var $img =
        '<img class="img0" src="' +
        Top.shoptetUpload +
        $obj.obr_cesta +
        c +
        '?v1">';

      if ((c1 = $val.obr_hover)) {
        var $imgHover =
          '<span><img class="img1" src="' +
          Top.shoptetUpload +
          $obj.obr_cesta +
          c1 +
          '?v2"></span>';
      }

      $obr = '<div class="obr">' + $img + $imgHover + "</div>";
    }

    var $nazevR = "<h4>" + $k + "</h4>";
    var $pocet = '<div class="pocet">' + b.Value + "x</div>";
    var $help = "";
    if ($tooltip) {
      $help = '<div class="help">' + $tooltip + "</div>";
    }

    $kod += '<div class="item">' + $obr + $nazevR + $pocet + $help + "</div>";
  } //for

  if (!$kod.length) return "";
  return '<div class="prava"><div class="flx">' + $kod + "</div></div>";
}

function pd_rozhrani(data) {
  Lc.f("pd_rozhrani");
  var $R = window.Parametry["PC_NTB"]["Rozhraní"];

  Lc.log(" $R", $R);
  Lc.log(" $data", data);

  var $a = pd_rozhrani_detail(data, $R);
  if (!$a.length) return "";
  var $kod = '<div class="leva"><h3>Rozhraní</h3></div>';

  return '<div class="rozhrani"><div class="flx">' + $kod + $a + "</div></div>";
}

function pd_hmotnost(data) {
  Lc.log(data);
  return "";
}

function pd_vybava_aj(data) {
  Lc.f("pd_vybava_aj");
  var $vybava, $loga, $hmotnosti;

  $hmotnosti = pd_hmotnost(data);

  //var $kod = '<div class="leva"><h3>Rozhraní</h3></div>';

  return (
    '<div class="rozhrani"><div class="flx">' +
    $vybava +
    $loga +
    $hmotnosti +
    "</div></div>"
  );
}

function pd_zobrazParametry(data) {
  Lc.f("pd_zobrazParametry", data);
  Lc.log("parametry", window.Parametry);

  var $kod = "";
  $kod += pd_sekce(data);

  $kod += pd_rozhrani(data);

  $kod += pd_vybava_aj(data);

  if (!$kod.length) return false;

  $('<div class="dvS">' + $kod + "</div>").appendTo("#dvParam");

  $("#dvParam .show-tooltip").tooltip({
    html: true,
    placement: "auto"
  });
}

function pd_nactiJson() {
  var code = window.getShoptetDataLayer("product").code;
  var url = urlServeru + code;

  var $PostData = {
    idProduktu: code
  };

  $.get(url, $PostData).done(function(data) {
    Lc.ajx("data", data);
    if (data.stav) {
      pd_zobrazParametry(data);
    }
    /*
    if (data.stav) {
      window.location.href = "/";
    } else {
      var $chyba = data.err;
      if (typeof data.hlaska !== "undefined") {
        $chyba = data.hlaska;
      }

      alertError($chyba);
    }
    */
  });
}

export function parametryDetailuProduktu() {
  Lc.f("parametryDetailuProduktu");
  pd_nactiJson();

  //nactiDoplnkyUpgrade();
  //zobrazDoplnkyUpgrade();
} //function  parametryDetailuProduktu()
